import Experience from './Experience/Experience.js'
import Cursor from './Experience/Utils/Cursor.js'

const cursor = new Cursor()
const experience = new Experience(document.querySelector('canvas.webgl'))

window.addEventListener('beforeunload', () => cursor.destroy())

